<template>
    <section class="py-16 px-4">
        <div
            class="max-w-2xl mx-auto text-center rounded-2xl border-2 border-dashed border-primary-200 bg-primary-50/30 py-16 px-8"
        >
            <div
                class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary-100 text-primary-600 mb-6"
                aria-hidden="true"
            >
                <svg
                    class="w-7 h-7"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
            </div>
            <h2 v-if="title" class="text-2xl font-headings font-bold text-primary-900 mb-2">
                {{ title }}
            </h2>
            <p class="text-primary-700 font-medium">
                A big update is coming soon.
            </p>
            <p class="text-primary-600 mt-1 text-sm">
                Watch this space.
            </p>
        </div>
    </section>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: ''
    }
})
</script>
